import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsPdfExpiredSvg = lazy(() => import('./svg-components/digital-forms-pdf-expired-svg'));

const DigitalFormsPdfExpiredSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsPdfExpiredSvg {...rest} />
  </Suspense>
);

export default DigitalFormsPdfExpiredSvg;
